import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  id?: string;
  className?: string;
  pulse?: boolean;
};
export function CTAButton({
  label,
  id,
  className = '',
  pulse = true
}: CTAButtonProps) {
  return <a id={id} href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-accent px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-lg shadow-accent/30 transition-transform duration-200 hover:bg-accent-dark active:scale-[0.98] sm:px-8 sm:py-5 sm:text-lg ${pulse ? 'cta-pulse' : ''} ${className}`} data-id="element-27" data-mp="2fz1z6gy9kmsv">
      <span data-id="element-28" data-mp="3cpcdk2frn8fc">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-29" data-mp="3cqni44h1ck7i" />
    </a>;
}
export function CTAMicroCopy({
  text
}: {
  text: string;
}) {
  return <p className="mt-3 text-center text-[11px] font-medium leading-relaxed text-navy-700/70 sm:text-sm" data-id="element-30" data-mp="19azfc6ps9zfn">
      {text}
    </p>;
}